const menuBtn = document.querySelector('.new__header--menu');
const nav = document.querySelector('.l_gNav');
const modalMask = document.querySelector('.modalMask');
const navLinks = document.querySelectorAll('.l_gNav a');

function openMenu() {
    nav.classList.add('active');
    modalMask.classList.add('active');
}

function closeMenu() {
    nav.classList.remove('active');
    modalMask.classList.remove('active');
}

function toggleMenu() {
    nav.classList.toggle('active');
    modalMask.classList.toggle('active');
}

// メニューボタンクリック
menuBtn.addEventListener('click', toggleMenu);

// モーダル背景クリック
modalMask.addEventListener('click', closeMenu);

// メニューリンククリック
navLinks.forEach(link => {
    link.addEventListener('click', closeMenu);
});

if (document.querySelector('.fv__slider')) {
    new Swiper('.fv__slider', {
        spaceBetween: 0,
        slidesPerView: 1.4,
        centeredSlides: true,
        loop: false,
        loopedSlides: 3,
        loopAdditionalSlides: 3,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // autoplay: {
        //   delay: 2000,
        //   disableOnInteraction: false,
        // },

        speed: 800,

        breakpoints: {
            768: {
                loop: false,
                slidesPerView: 1.5,
                spaceBetween: 25,
            }
        }
    });
}


const closeBtn = document.querySelector('.l_gNav--close');

closeBtn.addEventListener('click', closeMenu);

document.addEventListener("DOMContentLoaded", () => {
    const fadeInElements = document.querySelectorAll(".fade-in");

    const onScroll = () => {
        fadeInElements.forEach((el) => {
            const rect = el.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

            if (isVisible) {
                el.classList.add("show");
            }
        });
    };

    // スクロールイベントを監視
    window.addEventListener("scroll", onScroll);

    // ページ読み込み直後の状態も確認
    onScroll();
});


if (document.querySelector('.special__case--slider')) {
    new Swiper('.special__case--slider', {
        spaceBetween: 80,
        slidesPerView: 1,
        centeredSlides: true,
        loop: false,
        loopedSlides: 1,
        loopAdditionalSlides: 1,
        pagination: {
            el: ".swiper-pagination", // ページネーションのクラス名を指定
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        speed: 800,

        breakpoints: {
            768: {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 80,
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {

  // 各 swiper-slide ごとに処理
  document.querySelectorAll('.special__case--slider .swiper-slide').forEach(slide => {

    const charas = slide.querySelectorAll('.chara');
    const items = slide.querySelectorAll('.special__case--item');

    charas.forEach((chara, index) => {

      chara.addEventListener('click', () => {

        // active削除
        charas.forEach(el => el.classList.remove('active'));

        // show削除
        items.forEach(el => el.classList.remove('show'));

        // active追加
        chara.classList.add('active');

        // 対応するitem表示
        if (items[index]) {
          items[index].classList.add('show');
        }

      });

    });

  });

});

document.addEventListener('DOMContentLoaded', () => {

  const fixedBtn = document.querySelector('.fixed');

  window.addEventListener('scroll', () => {

    if (window.scrollY > 300) {
      fixedBtn.classList.add('show');
    } else {
      fixedBtn.classList.remove('show');
    }

  });

});


window.addEventListener('load', () => {

  const loading = document.querySelector('.loading');
  const closeBtn = document.querySelector('.loading__close');

  if (!loading) return;

  let closed = false;

  const closeLoading = () => {

    if (closed) return;
    closed = true;

    loading.classList.add('is-whiteout');

    setTimeout(() => {

      loading.style.opacity = '0';

      setTimeout(() => {

        loading.remove();

      }, 800);

    }, 300);

  };

  /* ×ボタン */
  if (closeBtn) {
    closeBtn.addEventListener('click', closeLoading);
  }

  /* 自動終了 */
  setTimeout(() => {
    closeLoading();
  }, 4200);

});